<template>
    <form action="/account" method="post">
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="recaptcha" :value="token">

        <div class="space-y-8 divide-gray-200 sm:space-y-5">
            <div class="space-y-6 sm:space-y-5">
                <div>
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        Personal Information
                    </h3>
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">
                        Please enter your details below
                    </p>

                </div>

                <div class="space-y-6 sm:space-y-4">
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div class="mt-1 relative rounded-md">
                            <TextInput
                                label="First Name"
                                name="first_name"
                                autocomplete="given-name"
                                v-model="form.first_name"
                                @change="form.validate('first_name')"
                            ></TextInput>
                        </div>
                        <div v-if="form.invalid('first_name')">
                            {{ form.errors.first_name }}
                        </div>
                    </div>

                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div class="mt-1 relative rounded-md">
                            <TextInput
                                label="Last Name"
                                name="last_name"
                                autocomplete="family-name"
                                v-model="form.last_name"
                                @change="form.validate('last_name')"
                            ></TextInput>
                        </div>
                        <div v-if="form.invalid('last_name')">
                            {{ form.errors.last_name }}
                        </div>
                    </div>

                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div class="mt-1 relative rounded-md">
                            <TextInput

                                label="Email"
                                name="email"
                                autocomplete="email"
                                type="email"
                                v-model="form.email"
                                @change="form.validate('email')"
                            ></TextInput>
                        </div>
                        <div v-if="form.invalid('email')">
                            {{ form.errors.email }}
                        </div>
                    </div>

                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div class="mt-1 relative rounded-md">
                            <TextInput
                                label="Password"
                                name="password"
                                autocomplete="new-password"
                                type="password"
                                v-model="form.password"
                                @change="form.validate('password')"
                            ></TextInput>
                        </div>
                        <div v-if="form.invalid('password')">
                            {{ form.errors.password }}
                        </div>
                    </div>

                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <div class="mt-1 relative rounded-md">
                            <TextInput
                                label="Password Confirmation"
                                name="password_confirmation"
                                autocomplete="new-password"
                                type="password"
                                v-model="form.password_confirmation"
                                @change="form.validate('password_confirmation')"
                            ></TextInput>
                        </div>
                        <div v-if="form.invalid('password')">
                            {{ form.errors.password_confirmation }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end mt-4">
            <button
                class="mx-auto w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-md tracking-wider font-medium rounded-md text-white bg-brand-orange hover:bg-brand-orange-dark">
                Create Account
            </button>
        </div>
    </form>
</template>

<script>
import { useForm } from 'laravel-precognition-vue';
import TextInput from '../TextInput.vue';

export default {
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            token: null,
        };
    },
    computed: {
        form() {
            return useForm('post', '/account', {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                password: '',
                password_confirmation: '',
                recaptcha: this.token,
                csrf: this.csrf,
            });
        },
    },
    mounted() {
        this.initRecaptcha();
        this.repopulateOldInput();
    },
    methods: {
        submit() {
            this.form.submit();
        },

        initRecaptcha() {
            this.$grecaptcha.ready(() => this.$grecaptcha.execute(this.$recaptchaKey, { action: 'login' }).then((token) => {
                this.token = token;
            }));
        },

        repopulateOldInput() {
            this.first_name = window.dataCore.old.first_name;
            this.last_name = window.dataCore.old.last_name;
            this.email = window.dataCore.old.email;
        },
    },
};
// export default {
//     data() {
//         return {
//             first_name: null,
//             last_name: null,
//             email: null,
//             password: null,
//             password_confirmation: null,
//             errors: [],
//             token: null,
//             csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
//         };
//     },
//     props: {
//         old: {
//             type: Object,
//             required: false,
//         },
//     },
//     methods: {
//         prefill() {
//             Object.assign(this.$data, this.old);
//         },

//         setRecaptchaToken() {
//             this.$grecaptcha.ready(() => this.$grecaptcha.execute(this.$recaptchaKey, { action: 'login' }).then((token) => {
//                 this.token = token;
//             }));
//         },

//         async onSubmit(e) {
//             const result = await this.v$.$validate();

//             if (!result) {
//                 console.log('error');
//                 e.preventDefault();
//                 return false;
//             }

//             return true;
//         },
//     },
//     mounted() {
//         if (this.old) {
//             this.prefill();
//         }

//         this.setRecaptchaToken();
//     },
//     components: {
//         TextInput,
//     },
// };
</script>
